import { User } from '@repo-level/core-front';
import { LocalStorage } from 'helpers/localStorage';

export const checkCompleteUserInformation = (
  user: User | undefined,
  isFR: boolean
) => {
  if (isFR) {
    return !!user?.firstName && !!user?.lastName && !!user?.dateOfBirth;
  }

  return (
    !!user?.firstName &&
    !!user?.lastName &&
    !!user?.dateOfBirth &&
    !!user?.mobilePhone &&
    !!user?.country &&
    !!user?.city &&
    !!user?.address &&
    !!user?.postalCode
  );
};

export const SELECTED_METHOD_KEY = 'selected-payment-method-id';

export const LocalStoragePaymentMethod = new LocalStorage<string | null, null>(
  SELECTED_METHOD_KEY,
  null
);
